import {LINKTYPES, SnackbarType} from '../../app/app-model/enums';
import {Privilege} from './privileges';

export interface ITranslation {
  [key: string]: any;
}

export interface CustomEventTarget extends EventTarget {
  innerText: string | undefined;
  classList: any;
  dataset: {[key: string]: string | undefined};
  value: string | undefined;
  closest: any;
  checked?: boolean;
}

export interface CustomListenerEvent extends Event {
  x: number;
  y: number;
  keyCode: number;
  target: CustomEventTarget;
  which?: number;
}

export interface CustomDivElement extends HTMLDivElement {
  hide?: Function;
}

export interface IToastOptions {
  animationIn?: string;
  animationOut?: string;
  image?: string;
  important?: string;
  icon?: string;
  text?: string;
  callbackOk?: Function;
  callbackCancel?: Function;
  buttonOk?: string;
  buttonCancel?: string;
  duration?: number;
  rounded?: boolean;
  type?: SnackbarType;
  classes?: string;
}

export interface IEventHandlerType {
  detail?: IEventHandlerInterface;
  [key: string]: any;
}

export interface IEventHandlerInterface {
  type?: string;
  value?: string | any;
  checked?: boolean;
  id?: string;
  [key: string]: any;
}

export enum SignupTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  ORGANISATION = 'ORGANISATION',
  BOTH = 'BOTH',
}

export enum FormModalTypeEnum {
  LOAD = 'LOAD',
  SAVE = 'SAVE',
}

export enum LOGINMODE {
  DATABASE_LOGIN_MODE = 'DATABASE-LOGIN-MODE',
  ACTIVE_DIRECTORY = 'ACTIVE-DIRECTORY',
}

export enum UserCategoryEnum {
  PRODUCT_ADMIN = 'PRODUCT_ADMIN',
  DEV = 'DEV',
  GUEST = 'GUEST',
}

export enum SeamIdUserTypeEnum {
  COMPANY = 'COMPANY',
  SEAMFIX_ADMIN = 'SEAMFIX_ADMIN',
}

export interface ChangePasswordInterface {
  newPassword: string;
  oldPassword: string;
}

export interface IDashboardModule {
  translationKey: string;
  type: LINKTYPES;
  privileges: Array<Privilege>;
}

export const LOCALSTORAGE_TRANSLATION_KEY = 'translation-language';

export const LOCALSTORAGE_CREDENTIAL_KEY = 'user-credential';

export const LOCALSTORAGE_TOKEN_KEY = 'auth-token';

export const LOCALSTORAGE_BASE_SETTING_KEY = 'baseSettings';

export const LOCALSTORAGE_SIGNUP_SETTING_KEY = 'signupSettings';

export const LOCALSTORAGE_SIGNUP_DETAILS_KEY = 'signUpDetails';

export const LOCALSTORAGE_SIGNUP_ORG_DETAILS_KEY = 'orgSignUpDetails';

export const LOCALSTORAGE_ORGANIZATIONS_KEY = 'organization-list';

export const LOCALSTORAGE_BILLABLE_INFO_KEY = 'billableInfo';

export const LOCALSTORAGE_USER_TIMEOUT_INFO_KEY = 'userTimeOut';

export const LOCALSTORAGE_USER_ALLOWED_TIME = 'userAllowedTime';

export const LOCALSTORAGE_CURRENT_CONTEXT_KEY = 'current-context';

export const LOCALSTORAGE_ALL_CATEGORY_KEY = 'all-category';

export const LOCALSTORAGE_CURRENT_CATEGORY_KEY = 'current-category';

export const LOCALSTORAGE_CONTEXT_ID_KEY = 'category-context-id';

export const LOCALSTORAGE_SRM_ID_KEY = 'context-srm-id';

export const LOCALSTORAGE_BASE_CONTEXT_DATA_KEY = 'base-context-data';

export const LOCALSTORAGE_PRODUCT_ID_KEY = 'app-product-id';

export const LOCALSTORAGE_RETURL_URL = 'setReturnUrl';

export const SUCCESS_CODE = 0;

export const LOCALSTORAGE_THEME = 'idqr-product-theme';

export const LOCALSTORAGE_APP_DEFAULT_THEME = 'LOCALSTORAGE_APP_DEFAULT_THEME';

export const LOCALSTORAGE_LINK_PROJECT_CONFIG = 'link-project-config';

export const LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG = 'link-role-type-config';

export const LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE = 'link-role-type';

export const LOCALSTORAGE_LINK_PROJECT_CODE = 'link-project-code';

export const LOCALSTORAGE_LINK_PROJECT_USER_DATA = 'link-project-user-data';

export const LOCALSTORAGE_LINK_PROJECT_USER_REG = 'link-project-user-reg';

export const LOCALSTORAGE_PROJECT_ID_CARD_ARTIFACT_KEY = 'project-id-card-artifact';

export const LOCALSTORAGE_PROJECT_ID_KEY = 'project-id';

export const LOCALSTORAGE_COMPANY_ID_KEY = 'company-id';

export const LOCALSTORAGE_USER_ID_KEY = 'user-id';

export const LOCALSTORAGE_LINK_PROJECT_RECEIPT_DATA = 'link-project-rec-data';

export const STUDENT_BIO_DATA = "student-bio-data";

export const STUDENT_FAILED_NIN = "student-failed-nin";

export const STUDENT_FAILED_NIN_VERIFICATION_COUNT = "student-failed-nin-verification-count";

export const STUDENT_FAILED_FACE_MATCH = "student-failed-face-match";

export const STUDENT_FAILED_FACE_MATCH_COUNT = "student-failed-face-match-count";

export const STAFF_BIO_DATA = "staff-bio-data";

export const STAFF_PHOTO_RETAKE_ACTION = "staff-photo-retake-action-state";

export const STAFF_FAILED_NIN = "staff-failed-nin";

export const STAFF_FAILED_NIN_VERIFICATION_COUNT = "staff-failed-nin-verification-count";

export const STAFF_FAILED_FACE_MATCH = "staff-failed-face-match";

export const STAFF_FAILED_FACE_MATCH_COUNT = "staff-failed-face-match-count";

export const LOCALSTORAGE_USER_AUTHORIZATION_DETAILS_KEY = "user-auth-details"

export const LOCALSTORAGE_USER_ACCOUNT_SETUP_DETAILS_KEY = "user-account-setup-details"

export const BULK_DOWNLOAD_ARCHIVE_BATCH_SETTINGS = "bulk-download-archive-batch-settings";

export const DASHBOARD_EMAIL_NOTIFICATION_SETTINGS = "dashboard-email-notification-settings";

export const BULK_ENGINE_STATE = 'bulk-engine-state';

export const LOCALSTORAGE_DASHBOARD_AGGREGATE_KEY = 'dashboard-aggregate';

export const LOCALSTORAGE_DASHBOARD_PAYMENTS_MADE_PROJECTS_KEY = 'dashboard-payments-made-by-projects';

export const LOCALSTORAGE_DASHBOARD_PRINTED_BY_PROJECTS_KEY = 'dashboard-printed-by-projects';

export const LOCALSTORAGE_DASHBOARD_CAPTURED_BY_PROJECTS_KEY = 'dashboard-captured-by-projects';

export const LOCALSTORAGE_DASHBOARD_ISSUED_BY_PROJECTS_KEY = 'dashboard-issued-by-projects';

export const LOCALSTORAGE_DASHBOARD_STAT_DATA_KEY = 'dashboard-stat-data';
